module.exports = __webpack_public_path__ + "static/media/login-bg.c9a09d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.png
// module id = 1654
// module chunks = 20